export const prependBaseUrl = path => `./${path}`;
export const prependAudioUrl = path => prependBaseUrl(`audios/${path}`);
export const prependCompositionUrl = path => prependBaseUrl(`compositions/${path}`);
